import Loader from "components/shared/loader";
import { paths } from "helpers/paths";
import { useRouter } from "hooks/useRouter";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { unsubscribeNotifications } from "sources/account";

const UnsubscribeNotifications = () => {
    const { query } = useRouter();
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        unsubscribeNotifications(query.token).then(() => {
            setLoading(false);
        });
    }, [query.token]);
    return (
        <div className="no-overflow h-100">
            <div className="identity-container">
                {loading && (
                    <div className="loader-snippet--disable-loader">
                        <Loader />
                    </div>
                )}
                <div className="identity-container__shadow" />
                <div className="identity-container__background" />
                <div className="identity-panel identity-panel--big">
                    <div className="identity-container__title" aria-label="Отмена подписки на уведомления" />
                    <h4>Вы успешно отменили подписку на уведомления из CARGO.RUN</h4>
                    <p className="pb-4">
                        Для того чтобы снова начать получать уведомления, настройте отправку писем в{" "}
                        <Link to={paths.profile}>профиле</Link>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default UnsubscribeNotifications;
